import script from "./UserJigoCode.vue?vue&type=script&setup=true&lang=js"
export * from "./UserJigoCode.vue?vue&type=script&setup=true&lang=js"

import "./UserJigoCode.vue?vue&type=style&index=0&id=687151ec&lang=css"

const __exports__ = script;

export default __exports__